import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { purpurColorFunctionalWhite, purpurColorRed600 } from '@purpurds/tokens/color/variables';
import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import styled, { css } from 'styled-components';
import { ComponentHeader } from '../component-header/component-header';
import { Loader } from 'components/loaders';
import { Icon } from '@purpurds/purpur/icon';
import { icons } from 'theme/icons';
import spacing from 'theme/spacing';
const Overlay = styled.div `
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 4;

  opacity: 0;
  pointer-events: none;
  transition: opacity 300ms ease;

  ${({ visible }) => visible &&
    css `
      opacity: 1;
      pointer-events: all;
    `}
`;
const ModalContainer = styled.div `
  background: ${purpurColorFunctionalWhite};
  width: 100%;

  height: 80dvh;
  border-radius: 8px 8px 0 0;

  display: flex;
  flex-direction: column;

  transform: translateY(100%);
  transition: transform 400ms ease;

  ${({ visible }) => visible &&
    css `
      transform: translateY(0);
    `}

  @media (min-width: 1024px) {
    height: 100dvh;
    border-radius: 4px;
    align-self: center;
  }
`;
const StyledIcon = styled(Icon) `
  cursor: pointer;
  color: ${purpurColorRed600};
  margin-right: ${spacing.spacing12};
`;
const Content = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  flex: 1;
  overflow-y: auto;
  width: calc(100% - 20px);
  max-width: 750px;
  margin-bottom: ${spacing.spacing8};
`;
export const SlideInModal = ({ children, display, onClose, cleanUp = () => { }, mainHeading, subHeading, isFetching = false, leftIcon, }) => {
    useEffect(() => {
        if (display)
            document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = '';
            cleanUp();
        };
    }, [display, cleanUp]);
    return ReactDOM.createPortal(_jsx(Overlay, { visible: display, onClick: onClose, children: _jsxs(ModalContainer, { visible: display, onClick: (e) => e.stopPropagation(), children: [_jsx(ComponentHeader, { rightIcon: _jsx(StyledIcon, { svg: icons.close, onClick: onClose, size: 'md' }), mainHeading: mainHeading || '', subHeading: subHeading, leftIcon: leftIcon }), _jsx(Content, { children: isFetching ? _jsx(Loader, { size: 56 }) : children })] }) }), document.getElementById('modal-root'));
};
